/**
 * Preprocesses text to ensure numbered lists are properly formatted
 * for ReactMarkdown parsing.
 * 
 * ReactMarkdown requires a blank line before a numbered list to parse it
 * as an <ol>. This function detects numbered list patterns and ensures
 * proper formatting.
 */
export function preprocessMarkdown(text: string): string {
  if (!text) return text;

  const lines = text.split('\n');
  const result: string[] = [];

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const prevLine = i > 0 ? lines[i - 1] : '';

    // Check if this line starts a numbered list item (e.g., "1. ", "2) ", "1: ")
    const isNumberedItem = /^\s*\d+[\.\)\:]\s/.test(line);
    const prevIsNumberedItem = /^\s*\d+[\.\)\:]\s/.test(prevLine);
    const prevIsBlank = prevLine.trim() === '';

    // If this is the first numbered item and the previous line isn't blank
    // and isn't also a numbered item, insert a blank line
    if (isNumberedItem && !prevIsNumberedItem && !prevIsBlank && i > 0) {
      result.push('');
    }

    result.push(line);

    // If this is the last numbered item and next line exists and isn't numbered/blank,
    // insert a blank line after
    if (isNumberedItem && i < lines.length - 1) {
      const nextLine = lines[i + 1];
      const nextIsNumberedItem = /^\s*\d+[\.\)\:]\s/.test(nextLine);
      const nextIsBlank = nextLine.trim() === '';
      if (!nextIsNumberedItem && !nextIsBlank) {
        // Don't add blank line yet - only after the LAST item in the list
      }
    }
  }

  return result.join('\n');
}
